module.exports = __webpack_public_path__ + "img/pic2.1aa6d722.png";